import { z } from '@/utils/zod'

export const OrganizationZoneSchema = z.enum(['campai'])

export type OrganizationZone = z.infer<typeof OrganizationZoneSchema>
